import { render, staticRenderFns } from "./kvportal.vue?vue&type=template&id=43e1ac49&"
import script from "./kvportal.vue?vue&type=script&lang=js&"
export * from "./kvportal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports